import { QuantityWithUOMAbbr } from "@/components/QuantityWithUOMAbbr";
import { ItemUOMSelectResult } from "@/features/job-tracking/queries/tracking-data/item-uoms";
import { Item } from "../queries/tracking-data/items";

export interface LineItemUOMQuantityProps {
  line: LineItemWithUOMQuantity;
}

export interface LineItemWithUOMQuantity {
  item: Item;
  /** Quantity for the line item in the selected ItemUOM */
  uomQuantity: number;
  /** Quantity for the line item converted to the base UOM */
  baseQuantity: number;
  itemUOM: ItemUOMSelectResult | null;
}

export const LineItemUOMQuantity: React.FC<LineItemUOMQuantityProps> = ({
  line: { item, uomQuantity, baseQuantity, itemUOM },
}) => {
  // If the line item does not have a UOM specified, show it without units
  if (!itemUOM) return <QuantityWithUOMAbbr quantity={uomQuantity} />;

  // If the line item has a UOM specified, but it is the base UOM, show it with units
  if (itemUOM.isBase) return <QuantityWithUOMAbbr quantity={uomQuantity} uom={itemUOM.uom} />;

  // Otherwise, show the quantity with the selected UOM units, and also using the base units in parentheses
  return (
    <>
      <QuantityWithUOMAbbr quantity={uomQuantity} uom={itemUOM.uom} /> (
      <QuantityWithUOMAbbr quantity={baseQuantity} uom={item.baseItemUOM?.uom} />)
    </>
  );
};
